import type { UpdateProfileInput } from "@recobra/schemas/user";

export const profileUpdateInput = (
  name: string,
  photo: string | null | undefined,
): UpdateProfileInput => ({
  name: name.trim(),
  ...(photo === null ? { picture: "" } : {}),
  ...(photo ? { photo: photo.split(",")[1] } : {}),
});
